import React from "react";

import { Title } from "./title";
import { Buttons, Props as ButtonsProps } from "./buttons";
import {
  KintoneExportSettingCreateForm,
  Props as CreateFormProps,
} from "./kintone-export-setting-create-form";

type Props = ButtonsProps & CreateFormProps;

export const KintoneExportSettingCreateContent: React.FC<Props> = ({
  tenant,
  selectedProcedure,
  kintoneAppUrl,
  isLoading,
  showDialog,
  showValidationErrorMessage,
  showKintoneApiErrorMessage,
  showNoEmailUserInGroupErrorMessage,
  onClickCreateOnPage,
  onClickCreateOnDialog,
  onClickCancelOnDialog,

  createKintoneExportSettingInput,
  onChange,
}) => {
  return (
    <>
      <Title />
      <Buttons
        tenant={tenant}
        selectedProcedure={selectedProcedure}
        kintoneAppUrl={kintoneAppUrl}
        isLoading={isLoading}
        showDialog={showDialog}
        showValidationErrorMessage={showValidationErrorMessage}
        showKintoneApiErrorMessage={showKintoneApiErrorMessage}
        showNoEmailUserInGroupErrorMessage={showNoEmailUserInGroupErrorMessage}
        onClickCreateOnPage={onClickCreateOnPage}
        onClickCreateOnDialog={onClickCreateOnDialog}
        onClickCancelOnDialog={onClickCancelOnDialog}
      />
      <KintoneExportSettingCreateForm
        createKintoneExportSettingInput={createKintoneExportSettingInput}
        onChange={onChange}
      />
    </>
  );
};
